/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {
    Positionable,
    SimpleReelModel,
    SimpleReelModelDelegate,
    SimpleReelModelState,
    SimpleReelModelSymbolData,
    SimpleReelModelSymbolPosition
} from "../../core/reel/simplereel/SimpleReelModel";
import {KennethMustDie} from "../KennethMustDie";
import {KMDSymbol} from "./KMDSymbol";
import {gsap} from "gsap";
import {KMDSpinSymbol} from "./KMDSpinSymbol";
import {SPECIAL_SYMBOL_NAMES} from "../server/IKMDData";

export class KMDReelsView extends PIXI.Container implements StageLayer, SimpleReelModelDelegate {
    protected _maskItem: PIXI.Graphics;

    constructor() {
        super();
        this.init();
    }

    protected _symbolContainer: PIXI.Container;

    get symbolContainer(): PIXI.Container {
        return this._symbolContainer;
    }

    private _reelModels: SimpleReelModel[];

    get reelModels(): SimpleReelModel[] {
        return this._reelModels;
    }

    public createSymbol(symbolName: string, state: SimpleReelModelState, symbolPosition: SimpleReelModelSymbolPosition): Positionable {
        let symbol: KMDSymbol | KMDSpinSymbol;

        if (state === SimpleReelModelState.SPIN) {
            // #486 -> point 2
            if (symbolName === SPECIAL_SYMBOL_NAMES.XH) {
                symbol = new KMDSymbol(symbolName);

                symbol.updateAnimation(SPECIAL_SYMBOL_NAMES.XH);
                symbol.playBlurStateForXH();
            } else {
                symbol = new KMDSpinSymbol(symbolName);
            }
        } else {
            symbol = new KMDSymbol(symbolName);
        }

        symbol.position.x = symbolPosition.reelID * KennethMustDie.SYMBOL_WIDTH + KennethMustDie.SYMBOL_WIDTH * 0.5;
        this._symbolContainer.addChildAt(symbol, 0);

        return symbol;
    }

    public removeSymbol(symbolData: SimpleReelModelSymbolData): void {
        (<PIXI.Sprite>symbolData.positionable).destroy({
            children: true
        });
    }

    public removeAvalancheSymbol(symbolData: SimpleReelModelSymbolData): void {
        this._symbolContainer.removeChild(<PIXI.Sprite>symbolData.positionable);
    }

    public toggleMask(visible: boolean): void {
        if (visible) {
            if (this._symbolContainer.mask === null) {
                this._symbolContainer.mask = this._maskItem;
                this._symbolContainer.addChild(this._maskItem);
            }
        } else {
            this._symbolContainer.mask = null;
            this._symbolContainer.removeChild(this._maskItem);
        }
    }

    // #281
    public turnOffForCFS(): void {
        this.alpha = 0;
    }

    // #281
    public transitionForCFS(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {
            duration: duration,
            alpha: 1
        });

        return tl;
    }

    protected init(): void {
        this._symbolContainer = new PIXI.Container();
        this._symbolContainer.position.set(0, KennethMustDie.MAIN_REELS_TOP);

        this._maskItem = new PIXI.Graphics();
        this._maskItem.beginFill();
        this._maskItem.drawPolygon([0, 0,
            0, -KennethMustDie.SYMBOL_HEIGHT * 2,
            KennethMustDie.SYMBOL_WIDTH, -KennethMustDie.SYMBOL_HEIGHT * 2,
            KennethMustDie.SYMBOL_WIDTH, -KennethMustDie.SYMBOL_HEIGHT * 3,
            KennethMustDie.SYMBOL_WIDTH * 4, -KennethMustDie.SYMBOL_HEIGHT * 3,
            KennethMustDie.SYMBOL_WIDTH * 4, -KennethMustDie.SYMBOL_HEIGHT * 2,
            KennethMustDie.SYMBOL_WIDTH * 5, -KennethMustDie.SYMBOL_HEIGHT * 2,
            KennethMustDie.SYMBOL_WIDTH * 5, 0]); // these are the vertices for the shape we want
        this._maskItem.endFill();
        this._maskItem.position.set(0, 375);

        this._symbolContainer.addChild(this._maskItem);
        this._symbolContainer.mask = this._maskItem;

        this.addChild(this._symbolContainer);

        this._reelModels = [];
        for (let i: number = 0; i < KennethMustDie.REELS_NUM; i++) {
            const reel: SimpleReelModel = new SimpleReelModel(i, this);
            reel.stepSize = KennethMustDie.SYMBOL_HEIGHT;
            reel.init(KennethMustDie.model.data.reels[i].concat());

            this._reelModels.push(reel);
        }
    }
}